import { isMostlyWhiteImageData } from '~/client/src/shared/utils/imageWhiteness'

const whitenessByUrl = new Map<string, Promise<boolean>>()

export function testWhiteImg(imageUrl: string): Promise<boolean> {
  // list filtering remounts rows; without this every keystroke re-scans
  const cached = whitenessByUrl.get(imageUrl)
  if (cached) return cached

  const result = new Promise<boolean>(resolve => {
    const img = new Image()

    img.onload = () => {
      const looksWhite = isMostlyWhiteImage(img, 0.5)
      resolve(looksWhite)
    }

    img.onerror = error => {
      console.error('Image failed to load:', error)
      console.error('Attempted path:', img.src)

      // not cached: a transient failure must not pin the answer for the session
      whitenessByUrl.delete(imageUrl)
      resolve(false)
    }

    // Set crossOrigin for Firebase Storage and other external images
    if (
      imageUrl.includes('firebasestorage.googleapis.com') ||
      !imageUrl.startsWith('/')
    ) {
      img.crossOrigin = 'anonymous'
    }

    img.src = imageUrl
  })

  whitenessByUrl.set(imageUrl, result)
  return result.catch(error => {
    whitenessByUrl.delete(imageUrl)
    throw error
  })
}

function isMostlyWhiteImage(
  img: HTMLImageElement,
  threshold: number = 0.1,
  maxBrightness: number = 240,
  maxAlpha: number = 10,
) {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  canvas.width = img.width
  canvas.height = img.height

  try {
    ctx.drawImage(img, 0, 0)

    const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height)

    return isMostlyWhiteImageData(data, { threshold, maxBrightness, maxAlpha })
  } catch (error) {
    console.error('CORS error or canvas tainted, cannot analyze image:', error)
    console.error('Image src:', img.src)
    console.error('crossOrigin setting:', img.crossOrigin)
    // Return false (assume not mostly white) when we can't analyze due to CORS
    return false
  }
}
